<template>
  <div class="form-box">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="农场名称" prop="farmName" required>
        <span class="form-txt">{{ ruleForm.farmName }}</span>
      </el-form-item>
      <el-form-item label="农事类型" prop="sysMissionCategoryName" required>
        <span class="form-txt">{{ ruleForm.sysMissionCategoryName }}</span>
        <!-- <el-button round size="medium" disabled>{{
          ruleForm.sysMissionCategoryName
        }}</el-button> -->
      </el-form-item>
      <el-form-item label="地块" prop="landIds">
        <el-button
          v-if="!ruleForm.landIds.length"
          round
          size="medium"
          class="select-btn"
          @click="chooseLandHandle"
          >选择地块</el-button
        >
        <el-button
          v-else
          round
          size="medium"
          type="text"
          @click="chooseLandHandle"
        >
          {{
            `已选择${ruleForm.landIds.length}个地块(共${ruleForm.landAcre}亩)`
          }}
        </el-button>
      </el-form-item>
      <el-form-item
        label="农资"
        prop="inputList"
        v-if="categoryType == 2 || categoryType == 3"
      >
        <el-button
          round
          size="medium"
          class="select-btn"
          v-show="!selectedResourcesList.length"
          @click="showArgicProduct = true"
          >选择农资</el-button
        >
        <div class="farm-resources" v-show="selectedResourcesList.length">
          <div class="btn-cell">
            <div class="add-resources-btn">
              <span class="addbtn" @click="showArgicProduct = true"
                >继续添加</span
              >
            </div>
          </div>
          <ul class="farm-resources-list">
            <li
              class="resources-list"
              v-for="(item, index) in selectedResourcesList"
              :key="item.agriResId"
            >
              <div class="main-info-box">
                <div class="left-info-box">
                  <img :src="item.firstAgriResCategoryImgUrl" alt="" />
                  <div class="production-info">
                    <p class="resources-name">
                      {{ item.agriResName }}
                    </p>
                    <p v-if="item.productor" class="resources-productor">
                      {{ item.productor }}
                    </p>
                  </div>
                </div>
                <div class="input-box">
                  <el-input
                    v-model="item.dose"
                    size="medium"
                    type="text"
                    maxlength="9"
                    :placeholder="
                      farmResourceInputType === 1 ? '每亩用量' : '总用量'
                    "
                    @input="numberLimit(item.dose, item.agriResId)"
                  ></el-input>
                  <span class="unit">{{ getUnit(item) }}</span>
                </div>
                <!-- TODO -->
                <!-- <div
                  class="ipt-tooltip"
                  v-show="
                    item.agrnumber &&
                    acreTotal &&
                    parseInt(supervisionFlag) === 1
                  "
                >
                  {{ parseFloat((item.agrnumber / acreTotal).toFixed(2))
                  }}{{ item.agriResMeterUnitName }}/<span
                    v-if="getPageParams().plotid"
                    >{{
                      getPageParams().landAcreUnit == 1
                        ? "亩"
                        : getPageParams().landAcreUnit == 2
                        ? "分"
                        : getPageParams().landAcreUnit == "3"
                        ? "平方米"
                        : ""
                    }}</span
                  ><span v-else>亩</span>
                </div> -->
              </div>
              <div v-if="item.skuName" class="nums">
                <p class="spec">规格：{{ item.skuName }}</p>
                <p class="stock">
                  待使用量：<span
                    :class="{ noStock: item.stockValueInMeter == 0 }"
                    >{{ clacStockByPack(item) }}{{ item.agriResPackUnitName
                    }}<i v-show="item.stockValueInMeter !== 0"
                      >（共{{ item.stockValueInMeter
                      }}{{ item.agriResMeterUnitName }}）</i
                    ></span
                  >
                </p>
              </div>
              <div class="remove-resource-btn show" @click="delCurRes(index)">
                <i class="iconfont icon-chahao"></i>
              </div>
            </li>
          </ul>
        </div>
      </el-form-item>
      <el-form-item label="作业方式" prop="operationMode">
        <el-radio-group v-model="ruleForm.operationMode">
          <el-radio
            v-for="item in operationModeArr"
            :key="item.label"
            :label="item.label"
            >{{ item.value }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="农事操作时间" prop="completeTime">
        <el-date-picker
          v-model="ruleForm.completeTime"
          type="date"
          value-format="yyyy-MM-dd"
          :clearable="false"
          placeholder="选择日期"
          :picker-options="pickerDateOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="操作人">
        <el-select
          class="chargeUser-input"
          v-model="ruleForm.chargeUserId"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in chargeUserList"
            :key="item.userId"
            :label="item.companyUserName"
            :value="item.userId"
          >
          </el-option>
        </el-select>
        <el-button class="chargeUser-add" @click="addStaffFn">添加</el-button>
      </el-form-item>
      <el-form-item label="农事照片">
        <div class="img-list">
          <div
            class="img-list-item"
            v-for="(img, idx) in ruleForm.imgUrls"
            :key="img + idx"
          >
            <el-image
              :src="img"
              :preview-src-list="ruleForm.imgUrls"
              :initial-index="idx"
            />
            <!-- <i class="el-icon-error" @click="removeImg(idx)"></i> -->
          </div>
          <p v-if="!ruleForm.imgUrls.length" class="img-tips">暂无农事图片</p>
          <!-- <el-upload
            ref="upload"
            v-if="ruleForm.imgUrls.length < 5"
            class="upload-img"
            :action="uploadAction"
            accept=".jpg,.gif,.png,.jpeg,.bmp,.pdf,.GIF,.BMP,.JPG,.JPEG,.PNG"
            name="files"
            multiple
            :on-change="handleFileChange"
            :auto-upload="false"
            :show-file-list="false"
            v-loading="uploading"
          >
            <div class="img-add">
              <i class="el-icon-plus"></i>
              上传图片
            </div>
          </el-upload> -->
        </div>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          type="textarea"
          maxlength="200"
          :rows="7"
          show-word-limit
          v-model="ruleForm.missionDesc"
        ></el-input>
      </el-form-item>
      <!-- 农机信息 -->
      <agric-info :agricInfo="njList"></agric-info>
      <!-- 提交按钮 -->
      <form-btn @submitForm="submitForm" @deleteForm="deleteForm"></form-btn>
    </el-form>
    <div class="land-shade" v-if="showLand && !closeOpen"></div>
    <div v-if="showLand && !closeOpen" class="land-content">
      <div class="land-content-list">
        <choose-land
          :selectLandLists="selectLandLists"
          @submit="chooseLandFun"
          @selectLandList="updateSelectLandList"
        ></choose-land>
      </div>
      <button class="close-btn" @click="closeHandle">
        <img src="@/assets/images/common/bg-close.png" alt="" />
      </button>
    </div>
    <!-- 操作人 -->
    <AddStaff
      :showFlag.sync="showAddStaffFlag"
      @update:showFlag="(val) => (showAddStaffFlag = val)"
      @updateMissionList="getOperateList()"
      @updateMissionId="(val) => (ruleForm.chargeUserId = val)"
    />
    <!-- 农资 -->
    <argic-product
      :sysMissionCategoryId="sysMissionCategoryId"
      :selectedList="selectedResourcesList"
      :showArgicProduct="showArgicProduct"
      @closeDialog="(val) => (showArgicProduct = val)"
      @updateSelectedList="updateSelectedList"
    ></argic-product>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import FormBtn from "../components/FormBtn";
import ChooseLand from "../ChooseLand/Index";
import AddStaff from "../components/AddStaff";
import ArgicProduct from "../components/ArgicProduct";
import AgricInfo from "../components/AgricInfo";
import { mapState, mapGetters } from "vuex";
import { numLimitCheck } from "@/utils";
import { getStorage } from "@/utils/storage";
import { snkd } from "@/api/api";
import { upload } from "@/api/request/snkd.foundation";
import {
  getDetail,
  saveMission,
  getDel,
  saveAndAudit,
} from "@/api/request/snkd.produce";
import { getOperateList } from "@/api/request/snkd.user";

export default {
  name: "AgricOperations",
  components: {
    FormBtn,
    ChooseLand,
    AddStaff,
    ArgicProduct,
    AgricInfo,
  },
  props: {
    isBack: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isBack(val) {
      if (val) {
        const ruleForm = {
          ...this.ruleForm,
          selectedResourcesList: this.selectedResourcesList,
          selectLandLists: this.selectLandLists,
        };
        if (JSON.stringify(this.originForm) === JSON.stringify(ruleForm)) {
          this.$router.go(-1);
        } else {
          const h = this.$createElement;
          this.$confirm("", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "confirm-dialog",
            message: h("div", [
              h(
                "p",
                {
                  style:
                    "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
                },
                `当前页面未保存！`
              ),
              h(
                "p",
                {
                  style:
                    "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
                },
                [
                  h(
                    "span",
                    null,
                    "是否确定返回？返回后将不对修改后的数据进行保存"
                  ),
                ]
              ),
            ]),
            type: "warning",
          })
            .then(async () => {
              this.$router.go(-1);
            })
            .catch(() => {
              this.$emit("updateStatus", false);
            });
        }
      }
    },
  },
  data() {
    return {
      fileLength: 0,
      curId: "",
      farmId: "",
      companyId: "",
      categoryType: "", // 农事id
      sysMissionCategoryId: 0, // 第一大类
      uploadAction: snkd.foundation.file.upload,
      uploading: false,
      selectLandLists: [],
      selectedResourcesList: [], //选中的农资
      showLand: false,
      showArgicProduct: false, //选择农资弹层
      showAddStaffFlag: false, //添加员工弹窗
      farmResourceInputType: 2, // 农资使用录入类型，1：按每亩用量录入；2：按总用量录入
      njList: [], //农机信息
      originForm: {}, //原始数据
      ruleForm: {
        farmName: "",
        sysMissionCategoryName: "",
        landIds: [],
        inputList: [],
        operationMode: 0,
        completeTime: new Date().format("yyyy.MM.dd"),
        chargeUserId: "",
        imgUrls: [],
        missionDesc: "",
        missionName: "", //同sysMissionCategoryName值
        landAcre: "",
      },
      rules: {
        landIds: [{ required: true, message: "请选择地块", trigger: "blur" }],
        inputList: [
          {
            validator: (rule, value, callback) => {
              if (!this.selectedResourcesList.length) {
                callback(new Error("请选择农资"));
              } else {
                let newArr = this.selectedResourcesList.some((item) => {
                  return !item.dose;
                });
                if (newArr) {
                  callback(new Error("请输入农资用量"));
                }
              }
              callback();
            },
            required: true,
            trigger: "change",
          },
        ],
        completeTime: [
          { required: true, message: "请选择农事操作时间", trigger: "blur" },
        ],
        operationMode: [
          { required: true, message: "请选择作业方式", trigger: "change" },
        ],
      },
      operationModeArr: [
        {
          label: 0,
          value: "人工",
        },
        {
          label: 1,
          value: "机械",
        },
      ],
      chargeUserList: [],
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  mounted() {
    this.curId = this.$route.query.id;
    //获取农场id
    const farminfo = getStorage("FARMINFO");
    if (getStorage("FARMINFO")) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
    this.getOperateList();
    this.getDetail();
  },
  computed: {
    ...mapState("damage", {
      closeOpen: "closeOpen",
    }),
    ...mapGetters("damage", ["hadSelectedLandList", "showLandList"]),
    //求和
    totalAcre() {
      return this.calcLandAcre(this.selectLandLists);
    },
  },
  methods: {
    submitForm(type) {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          console.log("校验通过");
          this.saveForm(type);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * type: 1、保存 2、保存并提交审核
     */
    async saveForm(type) {
      let fertilizerMedicineStashVO = this.selectedResourcesList.map((item) => {
        return {
          agriResId: item.agriResId,
          agriResSkuReceiveId: item.agriResSkuReceiveId,
          dosageType: 2, //写死2
          dose: item.dose,
        };
      });
      let params = {
        categoryType: this.categoryType,
        chargeUserId: this.ruleForm.chargeUserId,
        completeTime: this.ruleForm.completeTime + " 00:00:00",
        feedbackImgUrls: this.ruleForm.imgUrls.join(","),
        fertilizerMedicineStashVO: fertilizerMedicineStashVO,
        id: this.curId,
        landIds: this.ruleForm.landIds,
        operationMode: this.ruleForm.operationMode,
        missionDesc: this.ruleForm.missionDesc,
      };
      if (type === 1) {
        await saveMission(params).then((res) => {
          const { respCode, obj } = res;
          if (respCode === 0) {
            this.$message.success("保存成功");
            this.$router.go(-1);
          }
          console.log(respCode, obj);
        });
      } else {
        await saveAndAudit(params).then((res) => {
          const { respCode, obj } = res;
          if (respCode === 0) {
            this.$message.success("提交审核成功");
            this.$router.go(-1);
          } else if (respCode === 40012) {
            // 审核不成功
            this.auditFail();
          }
          console.log(respCode, obj);
        });
      }
    },
    async getDetail() {
      await getDetail({
        id: this.curId,
        companyId: this.companyId,
      }).then((res) => {
        const { respCode, obj } = res;
        console.log(respCode, obj);

        if (respCode === 0) {
          this.categoryType = obj.categoryType;
          this.ruleForm.farmName = obj.farmName;
          this.ruleForm.sysMissionCategoryName = obj.sysMissionCategoryName;
          this.ruleForm.operationMode = obj.operationMode;
          this.ruleForm.completeTime = obj.completeTime;
          this.ruleForm.chargeUserId = obj.chargeUserId;
          this.ruleForm.imgUrls =
            obj.feedbackImgUrls && obj.feedbackImgUrls.length
              ? obj.feedbackImgUrls.split(",")
              : [];
          this.fileLength = this.ruleForm.imgUrls.length;
          this.ruleForm.missionDesc = obj.missionDesc;
          //地块
          this.selectLandLists = obj.landList;
          this.ruleForm.landIds = this.selectLandLists.map((item) => item.id);
          this.ruleForm.landAcre = this.calcLandAcre(this.selectLandLists);
          //农资
          this.selectedResourcesList = obj.fertilizerMedicineStashVO;
          //删除农机信息的第一条数据
          this.njList = obj.njList || [];
          this.sysMissionCategoryId = obj.sysMissionCategoryId;
        }
        let originForm = {
          ...this.ruleForm,
          selectedResourcesList: this.selectedResourcesList,
          selectLandLists: this.selectLandLists,
        };
        this.originForm = JSON.parse(JSON.stringify(originForm));
      });
    },
    auditFail() {
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "知道了",
        showCancelButton: false,
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `审核未通过！`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            [h("span", null, "当前数据未审核成功，请手动重新审核。")]
          ),
        ]),
        type: "warning",
      })
        .then(() => {})
        .catch(() => {});
    },
    //操作人列表
    async getOperateList() {
      await getOperateList({
        companyId: this.companyId,
        farmId: this.farmId,
      }).then((res) => {
        const { respCode, obj } = res;
        if (respCode === 0) {
          this.chargeUserList = obj || [];
        }
      });
    },
    //更新农资列表
    updateSelectedList(item) {
      this.selectedResourcesList.push(item);
      console.log("this.selectedResourcesList", this.selectedResourcesList);
      this.$refs.ruleForm.validateField("inputList");
    },
    //打开添加员工弹窗
    addStaffFn() {
      this.showAddStaffFlag = true;
    },
    //选择地块
    updateSelectLandList(evt) {
      console.log("updateSelectLandList", evt);
      this.selectLandLists = evt;
    },
    //打开地块弹框
    chooseLandHandle() {
      this.$store.commit("damage/closeLand", false);
      this.$store.commit("damage/changeShowLandMode", "ListMode");
      this.showLand = true;
    },
    // 地块选择确定
    chooseLandFun() {
      this.ruleForm.landIds = this.selectLandLists.map((item) => item.id);
      this.ruleForm.landAcre = this.totalAcre;
    },
    //关闭地块弹框
    closeHandle() {
      this.showLand = false;
      this.ruleForm.landIds = this.selectLandLists.map((item) => item.id);
      this.ruleForm.landAcre = this.totalAcre;
      //清空筛选条件
      this.$store.commit("damage/clearPageAllStatus");
    },
    //求和
    calcLandAcre(list) {
      const countStr = list
        .reduce((total, cur) => {
          if (cur.statisticsLandAcre) {
            return total + cur.statisticsLandAcre;
          } else {
            return total + cur.landAcre;
          }
        }, 0)
        .toFixed(2);
      return parseFloat(countStr);
    },
    // 按包装单位计算库存
    clacStockByPack(info) {
      return parseFloat(
        (info.stockValueInMeter / info.skuSpecValue).toFixed(1)
      );
    },
    // 删除当前已选中农资
    delCurRes(idx) {
      this.selectedResourcesList.splice(idx, 1);
      this.$refs.ruleForm.validateField("inputList");
    },
    // 获取录入农资时的单位
    getUnit(item) {
      let u = item.unitName || item.agriResMeterUnitName;
      if (this.farmResourceInputType === 1) {
        return u + "/亩";
      } else {
        return u;
      }
    },
    numberLimit(value, agriResId) {
      this.selectedResourcesList.map((i) => {
        i.agrnumber = Number(i.dose);
        this.$forceUpdate();
      });
      if (value.indexOf("。") !== -1) {
        // 针对输入 。做处理
        value = value.replace("。", ".");
      }
      if (value.indexOf("..") !== -1) {
        // 针对 .. 做处理
        value = value.replace("..", ".");
      }
      var inx = this.selectedResourcesList.findIndex(
        (v) => v.agriResId == agriResId
      );
      value = numLimitCheck(value, 999999999, 0);
      this.selectedResourcesList[inx].dose = value;
    },
    // 上传发生变化钩子
    async handleFileChange(file) {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error("图片上传大小不超过10MB");
        return false;
      }
      if (this.fileLength >= 5) {
        this.$message.info("图片最多上传5张");
        return false;
      }
      this.fileLength = this.fileLength + 1;

      await this.submitFileForm(file);
    },
    // 提交上传文件
    async submitFileForm(file) {
      let formData = new FormData();
      const dir = "snkoudai/web/";
      const fileType = file.raw["type"];
      const index = fileType.lastIndexOf("/") + 1;
      const fileFormat = fileType.substring(index, fileType.length);
      var fileName = `${uuidv4()}.${fileFormat}`;
      formData.append("file", file.raw);
      formData.append("folderPath", dir);
      formData.append("originalFilename", fileName);
      this.uploading = true;
      await upload(formData)
        .then((res) => {
          const uploadRet = res && res.obj && res.obj.internetUrl;
          if (!uploadRet) return;
          if (this.ruleForm.imgUrls.length >= 5) return;
          this.ruleForm.imgUrls.push(res.obj.internetUrl);
          this.uploading = false;
        })
        .catch(() => {
          this.$message.error("上传失败！");
          this.uploading = false;
        });
    },
    removeImg(idx) {
      this.ruleForm.imgUrls.splice(idx, 1);
      this.fileLength = this.fileLength - 1;
    },
    async deleteForm() {
      await getDel({
        idList: [this.curId],
      }).then((res) => {
        const { respCode } = res;
        if (respCode === 0) {
          this.$message({
            type: "success",
            message: "删除成功！",
          });
          this.$router.go(-1);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.form-box {
  background: #fff;
  .demo-ruleForm {
    padding: 40px;
    width: 50%;
    margin: 0 auto;
    .form-txt {
      color: #c0c4cc;
    }
    .farm-resources {
      width: 529px;
      padding: 25px 20px;
      box-sizing: border-box;
      border-radius: 3px;
      background: rgba(246, 248, 251, 0.9);
      .btn-cell {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        .add-resources-btn span.addbtn {
          font-size: 14px;
          line-height: 14px;
          font-weight: 400;
          color: #64c3a4;
          cursor: pointer;
          margin-top: 0;
        }
        .switch-btn {
          font-size: 12px;
          font-weight: 400;
          color: #ff831e;
          cursor: pointer;
          .iconfont {
            font-size: 12px;
          }
        }
      }
      .farm-resources-list {
        li {
          position: relative;
          width: 488px;
          margin-top: 20px;
          box-sizing: border-box;
          padding: 0 20px;
          background: #eaeef4;
          border-radius: 3px;
          .main-info-box {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 80px;
          }
          .nums {
            display: flex;
            align-items: center;
            margin-left: 36px;
            font-size: 12px;
            color: #888888;
            margin-top: -4px;
            padding-bottom: 16px;
            .spec {
              margin-right: 49px;
            }
            span {
              color: #64c3a4;
              &.noStock {
                color: #ff831e;
              }
            }
          }
          .left-info-box {
            display: flex;
            align-items: center;
            height: 100%;
            img {
              width: 26px;
              height: 26px;
              margin-right: 10px;
            }
            .production-info {
              width: 215px;
              white-space: nowrap;
              .resources-name {
                height: 15px;
                line-height: 15px;
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                text-overflow: ellipsis;
                overflow: hidden;
              }
              .resources-productor {
                height: 12px;
                line-height: 12px;
                margin-top: 10px;
                font-size: 12px;
                font-weight: 400;
                color: #888888;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
          }
          .input-box {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            // width: 140px;
            width: 156px;
            height: 28px;
            padding: 0 10px;
            box-sizing: border-box;
            background: #ffffff;
            border: 1px solid #e5e5e5;
            border-radius: 4px;
            .unit {
              font-size: 14px;
              font-weight: 400;
              color: #888888;
              white-space: nowrap;
            }
            .el-input {
              // width: 60px;
              width: 100%;
              height: 26px;
              line-height: 26px;
              border: 0 none;
              box-sizing: border-box;
              font-size: 14px;
              ::v-deep .el-input__inner {
                height: 26px;
                line-height: 26px;
                border: none;
              }
              &::-webkit-input-placeholder {
                font-size: 14px;
                font-weight: 400;
                color: #b2b2b2;
              }
              &::-moz-placeholder {
                font-size: 14px;
                font-weight: 400;
                color: #b2b2b2;
              }
              &:-moz-placeholder {
                font-size: 14px;
                font-weight: 400;
                color: #b2b2b2;
              }
              &:-ms-input-placeholder {
                font-size: 14px;
                font-weight: 400;
                color: #b2b2b2;
              }
            }
          }
          .ipt-tooltip {
            position: absolute;
            color: #ff831e;
            right: 0px;
            top: 60px;
          }
          .total-value {
            font-size: 14px;
            font-weight: 400;
            color: #888888;
            span.num {
              font-size: 20px;
              font-weight: 400;
              color: #333333;
              margin-right: 5px;
            }
          }
          .remove-resource-btn {
            position: absolute;
            top: -10px;
            right: -10px;
            width: 20px;
            height: 20px;
            display: none;
            justify-content: center;
            align-items: center;
            background: #c3c7cd;
            border-radius: 50%;
            .iconfont {
              font-size: 12px;
              color: #ffffff;
              margin: 0;
              cursor: pointer;
            }
          }
          &:first-child {
            margin: 0;
          }
          &:hover {
            .remove-resource-btn.show {
              display: flex;
            }
          }
        }
      }
    }
    .el-button--medium.el-button--text {
      padding: 0;
    }
    .select-btn {
      border: 1px solid #64c3a4;
      color: #64c3a4;
    }
    .farm-resources {
      width: 529px;
      padding: 25px 20px;
      box-sizing: border-box;
      border-radius: 3px;
      background: rgba(246, 248, 251, 0.9);
      .btn-cell {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        .add-resources-btn span.addbtn {
          font-size: 14px;
          line-height: 14px;
          font-weight: 400;
          color: #64c3a4;
          cursor: pointer;
          margin-top: 0;
        }
        .switch-btn {
          font-size: 12px;
          font-weight: 400;
          color: #ff831e;
          cursor: pointer;
          .iconfont {
            font-size: 12px;
          }
        }
      }
      .farm-resources-list {
        li {
          position: relative;
          width: 488px;
          margin-top: 20px;
          box-sizing: border-box;
          padding: 0 20px;
          background: #eaeef4;
          border-radius: 3px;
          .main-info-box {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 80px;
          }
          .nums {
            display: flex;
            align-items: center;
            margin-left: 36px;
            font-size: 12px;
            color: #888888;
            margin-top: -4px;
            padding-bottom: 16px;
            .spec {
              margin-right: 49px;
            }
            span {
              color: #64c3a4;
              &.noStock {
                color: #ff831e;
              }
            }
          }
          .left-info-box {
            display: flex;
            align-items: center;
            height: 100%;
            img {
              width: 26px;
              height: 26px;
              margin-right: 10px;
            }
            .production-info {
              width: 215px;
              white-space: nowrap;
              .resources-name {
                height: 15px;
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                text-overflow: ellipsis;
                overflow: hidden;
              }
              .resources-productor {
                height: 12px;
                margin-top: 10px;
                font-size: 12px;
                font-weight: 400;
                color: #888888;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
          }
          .input-box {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            // width: 140px;
            width: 156px;
            height: 28px;
            padding: 0 10px;
            box-sizing: border-box;
            background: #ffffff;
            border: 1px solid #e5e5e5;
            border-radius: 4px;
            .unit {
              font-size: 14px;
              font-weight: 400;
              color: #888888;
              white-space: nowrap;
            }
            input {
              // width: 60px;
              width: 76px;
              height: 26px;
              line-height: 26px;
              border: 0 none;
              box-sizing: border-box;
              font-size: 14px;
              &::-webkit-input-placeholder {
                font-size: 14px;
                font-weight: 400;
                color: #b2b2b2;
              }
              &::-moz-placeholder {
                font-size: 14px;
                font-weight: 400;
                color: #b2b2b2;
              }
              &:-moz-placeholder {
                font-size: 14px;
                font-weight: 400;
                color: #b2b2b2;
              }
              &:-ms-input-placeholder {
                font-size: 14px;
                font-weight: 400;
                color: #b2b2b2;
              }
            }
          }
          .ipt-tooltip {
            position: absolute;
            color: #ff831e;
            right: 0px;
            top: 60px;
          }
          .total-value {
            font-size: 14px;
            font-weight: 400;
            color: #888888;
            span.num {
              font-size: 20px;
              font-weight: 400;
              color: #333333;
              margin-right: 5px;
            }
          }
          .remove-resource-btn {
            position: absolute;
            top: -10px;
            right: -10px;
            width: 20px;
            height: 20px;
            display: none;
            justify-content: center;
            align-items: center;
            background: #c3c7cd;
            border-radius: 50%;
            .iconfont {
              font-size: 12px;
              color: #ffffff;
              margin: 0;
              cursor: pointer;
            }
          }
          &:first-child {
            margin: 0;
          }
          &:hover {
            .remove-resource-btn.show {
              display: flex;
            }
          }
        }
      }
    }
    .img-list {
      display: flex;
      &-item {
        position: relative;
        line-height: 1;
        ::v-deep .el-image {
          width: 100px;
          height: 100px;
          border-radius: 4px;
          margin-right: 10px;
        }
        .el-icon-error {
          position: absolute;
          right: 2px;
          top: -8px;
          font-size: 18px;
          background-color: #fff;
          border-radius: 50%;
          color: #dadada;
          box-sizing: border-box;
          cursor: pointer;
        }
      }
      .img-tips {
        color: #666;
      }
    }
    .upload-img {
      ::v-deep .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        width: 100px;
        height: 100px;
        cursor: pointer;
        line-height: 98px;
        vertical-align: top;
        color: #8c939d;
      }
    }
    .chargeUser-input {
      width: 370px !important;
    }
    .chargeUser-add {
      margin-left: 20px;
    }
    ::v-deep .el-input__inner {
      width: 100%;
    }
    ::v-deep .el-textarea,
    .el-date-editor,
    .el-textarea__inner {
      width: 100%;
    }
  }
  .land-shade {
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
    opacity: 0.3;
    z-index: 5;
    position: absolute;
    top: 0px;
    left: 0;
  }
  .land-content {
    position: absolute;
    top: 13%;
    left: 0;
    right: 0;
    width: 1200px;
    height: 85%;
    z-index: 10;
    margin: 0 auto;
    .land-content-list {
      width: 100%;
      height: 95%;
      background-color: #fff;
      margin: 0 auto;
      border-radius: 10px;
      padding: 10px;
      position: relative;
    }
    .close-btn {
      position: absolute;
      right: -5%;
      top: 0;
      height: 36px;
      width: 36px;
      border: 2px solid #fff;
      border-radius: 50%;
      outline: 0;
      background-color: rgb(0, 0, 0);
      opacity: 0.2;
      cursor: pointer;
      img {
        vertical-align: middle;
      }
    }
  }
  .land-select {
    font-size: 14px;
    font-weight: 400;
    color: #64c3a4;
    cursor: pointer;
  }
}
</style>
